import { render, staticRenderFns } from "./VehicleSourceInformationField.vue?vue&type=template&id=4fb9e7e4&scoped=true"
import script from "./VehicleSourceInformationField.vue?vue&type=script&lang=ts"
export * from "./VehicleSourceInformationField.vue?vue&type=script&lang=ts"
import style0 from "./VehicleSourceInformationField.vue?vue&type=style&index=0&id=4fb9e7e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb9e7e4",
  null
  
)

export default component.exports